<template>
    <report-wrapper>
        <template v-slot:title>
            Expenditures by Cost Type Report
        </template>

        <b-row align-h="end" align-v="center">
            <b-col md="5" class="my-2">
                <b-input-group prepend="Academic Year">
                    <b-form-select v-model="aySelect" :options="ayOptions" @change="handleChange">
                        <template slot="first">
                            <b-form-select-option :value="null" disabled>
                                Filter the table by academic year
                            </b-form-select-option>
                        </template>
                    </b-form-select>
                    <b-input-group-append>
                        <b-button :disabled="!aySelect" @click="aySelect = ''">
                            Clear
                        </b-button>
                    </b-input-group-append>
                </b-input-group>
            </b-col>
        </b-row>

        <div>
            <b-table
                bordered
                striped
                hover
                responsive
                outlined
                small
                :tbody-tr-attr="{align: 'right'}"
                :tbody-tr-class="rowClass"
                :fields="reportFields"
                :items="reportData"
                show-empty
                empty-text="There are currently no records to show."
            />
        </div>
    </report-wrapper>
</template>

<script>
import ReportWrapper from './ReportWrapper';
import { Arc } from '$Shared/@arc/vue-arc';
import { mapGetters, mapState, mapActions } from 'vuex';

export default {
    name: 'ExpendituresByCostTypeReport',

    metaInfo() {
        return { title: 'ExpendituresByCostTypeReport' };
    },

    components: {
        'report-wrapper': ReportWrapper,
    },

    data() {
        return {
            aySelect: null,
        };
    },

    computed: {
        ...mapState('reports', {
            rawReportData: 'reportData',
        }),
        ...mapGetters({
            currentAy: 'ref/global/currentAy',
        }),

        reportName() {
            // strip 'Report' from name
            return this.$options.name.substring(0, this.$options.name.length - 6);
        },

        reportData() {
            return this.rawReportData ? this.rawReportData : [];
        },

        ayOptions() {
            let options = [];
            let allAy = [];
            const previousAy = Number(this.currentAy) - 1;
            const curAy = Number(this.currentAy);
            allAy.push(previousAy);
            allAy.push(curAy);
            options = allAy.filter((value, index, self) => {
                return self.indexOf(value) === index;
            });
            return options;
        },

        targetAy() {
            return (this.aySelect)
                ? Number(this.aySelect) + 1
                : Number(this.currentAy) + 1;
        },

        reportFields() {
            return [
                { key: 'academic_year', label: 'AY' },
                { key: 'applicant_short_name', label: 'Applicant', sortable: true },
                { key: 'cost_type_name', label: 'Cost Type', sortable: true },
                {
                    key: 'funds_perkins',
                    label: 'Amount Budgeted',
                    sortable: true,
                    formatter: value => Arc.Money.asCurrency(value),
                }, {
                    key: 'funds_perkins_purchased',
                    label: 'Amount Purchased',
                    sortable: true,
                    formatter: value => Arc.Money.asCurrency(value),
                }, {
                    key: 'funds_perkins_available',
                    label: 'Amount Available',
                    sortable: true,
                    formatter: value => Arc.Money.asCurrency(value),
                },
            ];
        },
    },

    async created() {
        (this.aySelect)
            ? this.handleChange()
            : this.fetchReport({ name: this.reportName, ay: this.currentAy });
    },

    methods: {
        ...mapActions({
            fetchReport: 'reports/fetchReport',
        }),

        handleChange(event) {
            this.fetchReport({ name: this.reportName, ay: this.aySelect });
        },

        rowClass(item, type) {
            if (!item || type !== 'row') return;
            if (item.funds_perkins <= 0) return 'table-warning';
        },
    },
};
</script>

<style scoped lang="scss">
</style>
